import React from 'react';

import { CommonStyles } from '~commonInfra/styles/CommonStyles';
import { Set } from '~commonInfra/utils/Set';

import { cssClass, fillStyle } from '../../style';
import { ChangeSimulationsTagsAction } from '../actions/ChangeSimulationsTagsAction';
import { SimulationSubspaceProps } from '../types/SimulationSubspaceProps';
import { SimulationDescription } from './SimulationDescription';
import { SimulationTags } from './SimulationTags';

const cssPrefix = 'SimulationOverviewSubspace';

const rootClass = cssClass(cssPrefix, 'root', fillStyle, {
  overflow: 'auto'
});


const contentClass = cssClass(cssPrefix, 'content', {
  padding: `${CommonStyles.Sizes.MediumSpace}px ${CommonStyles.Sizes.MediumSpace}px ${CommonStyles.Sizes.MediumSpace}px ${CommonStyles.Sizes.LargeSpace}px`
});


export type SimulationOverviewSubspaceState = {
};

export class SimulationOverviewSubspace extends React.Component<SimulationSubspaceProps, SimulationOverviewSubspaceState> {


  private unmounted: boolean = false;

  constructor(props: SimulationSubspaceProps) {
    super(props);

    this.state = {
    };
    this.fetchData();
  }

  private fetchData = () => {
    if (!this.unmounted) {
    }
  };


  private refreshData = () => {
    if (!this.unmounted) {
      this.props.refreshData();
    }
  };

  private editTags = () => {
    const singleton = Set.singletonForIdItem(this.props.simulationDetailInfo);
    ChangeSimulationsTagsAction.execute(singleton).then(() => this.refreshData());
  };

  private renderDescription = (): JSX.Element => {
    return this.props.simulationAllowedActions.setDescription || this.props.simulationDetailInfo.description ? (
      <div className={contentClass}>
        <SimulationDescription
          simulationDetailInfo={this.props.simulationDetailInfo}
          editDescriptionAllowed={this.props.simulationAllowedActions.setDescription}
          refreshData={this.refreshData}
          sanitizer={this.props.sanitizer}
        />
      </div>
    ) : null;
  };

  private renderTags = (): JSX.Element => {
    return this.props.simulationAllowedActions.setTags || this.props.simulationDetailInfo.tags.length ? (
      <div className={contentClass}>
        <SimulationTags
          editTagAllowed={this.props.simulationAllowedActions.setTags}
          editTags={this.editTags}
          siteUrls={this.props.siteUrls}
          tags={this.props.simulationDetailInfo.tags}
        />
      </div>
    ) : null;
  };

  public componentDidUpdate(prevProps: SimulationSubspaceProps) {
    if (prevProps.simulationDetailInfo.id !== this.props.simulationDetailInfo.id) {
      this.fetchData();
    }
  }

  public componentWillUnmount() {
    this.unmounted = true;
  }


  public render(): JSX.Element {
    return (
      <div className={rootClass}>
        { this.renderDescription() }
        { this.renderTags() }
      </div>
    );
  }
}
